// 아이디: 영숫자·._%+- (끝 글자 제한 없음) · 도메인: 라벨 1개 이상 + TLD 2자 이상.
// 종전 /^\w+([\.-]?\w+)*@…(\.\w{2,3})+$/ 는 아이디가 \w 로 끝나야 해서 `feelgood-@kakao.com` 을 거절했고
// `+` 태그·4자 이상 TLD 도 막았다(2026-08-31 초대 고객 로그인 불가). 백엔드는 형식 검증이 없어 프론트만 막던 것.
export const regexEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

export const regexNotNumber = /[^0-9]/g;
export const regexPhoneNumber = /^(01[016789]{1})(\d{0,4})(\d{0,4})$/g;
